import request from '@/router/axios';

/**
 * 获取角色列表
 * @param {Object} params 参数
 */
export const getRoleList = (params = {}) => {
    return request('/api/system/role/select', {
        params
    })
}